import { render } from "./AssignClaimRequest.vue?vue&type=template&id=f4aadd38"
import script from "./AssignClaimRequest.vue?vue&type=script&lang=js"
export * from "./AssignClaimRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__